import { Link } from "react-router-dom";

const stats = [
  { value: "128", label: "本季新番导视" },
  { value: "12", label: "今日最新上架" },
  { value: "36", label: "连载新开作品" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[520px] w-full items-center justify-center overflow-hidden pt-16 md:min-h-[600px]">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20anime%20manga%20collage%20background%20with%20floating%20comic%20panels%20and%20dynamic%20energy%20bursts%2C%20warm%20orange%20and%20coral%20sunset%20sky%2C%20silhouettes%20of%20characters%20leaping%2C%20sparkles%20and%20speed%20lines%2C%20abstract%20cinematic%20manga%20illustration%2C%20vibrant%20warm%20tones%2C%20no%20text%2C%20clean%20and%20expressive&width=1800&height=1000&seq=papaya-hero-01&orientation=landscape"
        alt="番木瓜漫画本季新番导视 横幅插画"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/60"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-16 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-100/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-secondary-300"></i>
          番木瓜漫画 · 本季新作抢先看，最新上架每日更新
        </span>
        <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          新番导视 · 每日上架 · 热门新番
          <span className="mt-2 block text-primary-300">一站掌握追更节奏</span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-background-100/90 md:text-lg">
          番木瓜漫画当季导视帮你快速锁定值得追的作品，最新上架每日更新不漏追，热门新番同步追更，连载新开抢先发现，让每一次追番都有好去处。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/guide"
            className="flex w-full items-center justify-center rounded-full bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-600 whitespace-nowrap sm:w-auto"
          >
            浏览本季新番导视
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/hot"
            className="flex w-full items-center justify-center rounded-full border border-background-100/40 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition hover:bg-background-50/20 whitespace-nowrap sm:w-auto"
          >
            看看热门新番
          </Link>
        </div>

        <div className="mx-auto mt-10 grid max-w-lg grid-cols-3 gap-3 rounded-2xl border border-background-100/20 bg-foreground-950/30 p-4 backdrop-blur">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-heading text-2xl text-secondary-300 md:text-3xl">
                {s.value}
              </p>
              <p className="mt-1 text-xs text-background-100/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}